import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
   Box,
   Typography,
   Card,
   MenuItem,
   FormControl,
   Select,
   TextareaAutosize,
   Dialog,
   Menu,
   Button,
   CircularProgress,
   Popover,
   Divider,
   DialogTitle,
   DialogContent,
   DialogActions,
   TextField,
} from '@mui/material';

import _ from 'lodash';

import cost from '../../../assets/cost.svg';
import { useNavigate } from 'react-router-dom';
import contactImg from '../../../assets/FAB.svg';
import Contact from '../../../assets/listContact.png';
import { Container } from './style';
import backImg from '../../../assets/back.svg';
import up from '../../../assets/up.png';
import sendingImg from '../../../assets/sending.gif';
import verticalMenu from '../../../assets/verticalMenu.svg';
import scheduleImg from '../../../assets/icon.png';
import styled from '@emotion/styled';
import ScheduleDate from '../../../components/message/scheduleMessage/ScheduleDate';
import MessageContact from '../messageContact';
import MessageSummary from '../../../components/message/messageHome/MessageSummary';
import GroupSelect from '../../../components/message/select/GroupSelect';
import ContactContent from './ContactContent';
import { useDispatch, useSelector } from 'react-redux';
import { messageSelector } from '../../../components/utils/selectors/selectors';
import GroupContent from './GroupContent';
import {
   draftmessage,
   fetchsenderIDs,
   getMsgCost,
   resetCreated,
   schedulemessage,
   sendmessage,
   selectSenderId,
   resetSelectedContacts,
   updateSelectedContent,
} from '../../../components/app/features/message/messageSlice';
import Success from './Success';
import { toast } from 'react-toastify';
import dayjs from 'dayjs';
import NotificationPopup from '../../../components/NotificationPopup/NotificationPopup';
import { userLSAuth } from '../../../components/app/features/env';
import InsufficientSmsDialog from '../../../components/modal/InsufficientUnits';
import { setIn } from 'formik';

const Textarea = styled(TextareaAutosize)(
   ({ theme }) => `
		width: 100%;
		min-height: 150px;
      padding: 10px;
		border: 1px solid #E5E5E5;
		border-radius:5px;
		font-size: ${theme?.breakpoints?.down('sm') ? '0.9rem' : '1rem'};
      background: white;
      color: #49454F;
		margin-top: 2rem;
		&:focus {
      outline: none;
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
    },
     `
);
const DropDown = styled(Menu)(
   ({ theme }) => `
	position: absolute;
	right: 0;

& .MuiPopover-paper {
	border-radius:0;
}
& .MuiList-root, & .MuiMenu-list {
	padding:0;
	border-radius:0;
}

	`
);
const Activity = styled(MenuItem)(
   ({ theme }) => `
	min-height:unset;
	padding:5px 0 5px 15px;
 box-sizing: border-box;
 white-space: nowrap;
	width: 160px;
	font-weight:600;
	border-radius:0;
	`
);

const Message = () => {
   const selector = useSelector(messageSelector);
   const dispatch = useDispatch();
   const [anchorEl, setAnchorEl] = React.useState(null);
   const [period, setPeriod] = React.useState(false);
   const [draftOpen, setDraftOpen] = React.useState(false);
   const [add, setAdd] = React.useState(false);
   const [openSummary, setOpenSummary] = React.useState(false);
   const [selectGroup, setSelectGroup] = React.useState(false);
   const [open, setOpen] = React.useState(false);
   const [scheduleSuccess, setScheduleSuccess] = React.useState(false);
   const [schedule, setSchedule] = React.useState(false);
   const [action, setAction] = React.useState('');
   const [text, setText] = React.useState(selector.selectedContent);
   const [numOfContacts, setNumOfContacts] = React.useState(0);
   const [senderId, setSenderId] = React.useState(selector?.selectedSenderId);
   const [openProgress, setOpenProgress] = React.useState(false);
   const [sendProgress, setSendProgress] = React.useState(false);
   const actions = ['Save to Drafts'];
   const balance = userLSAuth()?.balance;
   const [totalCost, setotalCost] = React.useState('');
   const [insufficient, setInsufficient] = React.useState(false);
   const [maxCharactersPerPage, setMaxCharactersPerPage] = React.useState(160);
   const [messageId, setMessageId] = React.useState();
   const navigate = useNavigate();
   const [anchorEl2, setAnchorEl2] = React.useState(null);
   const [isTemplateDialogOpen, setIsTemplateDialogOpen] =
      React.useState(false);
   const [selectedTemplate, setSelectedTemplate] = React.useState(null);
   const [expandedId, setExpandedId] = React.useState(null);
   const isOpen = Boolean(anchorEl2);
   const [selectedCategory, setSelectedCategory] = useState('');
   const [selectedType, setSelectedType] = useState('');
   const [isOpen2, setIsOpen] = useState(false);
   // Template data
   const templates = [
      {
         id: 1,
         category: 'Easter',
         preview:
            'Easter is a reminder of new beginnings! As we celebrate this season, may the possibility of his resurrection inspire you to take on new opportunities with hope and courage.',
      },
      {
         id: 2,
         category: 'Easter',
         preview:
            'Just like he rewrote the plot when he rolled the stone on the 3rd day, may this also be your season of beautiful turnarounds. Happy Easter Celebration!',
      },
      {
         id: 3,
         category: 'Easter',
         preview:
            'He is risen! May the resurrection of Christ fill your heart with hope and renew your spirit. Wishing you a blessed and joyful Easter filled with love, grace, and faith.',
      },
      {
         id: 4,
         category: 'Eid (Muslim holidays)',
         preview:
            'Ramadan is a time to come together in love, faith, and kindness. May this special month inspire compassion and strengthen the bonds we share. Ramadan Kareem!',
      },
      {
         id: 5,
         category: 'Eid (Muslim holidays)',
         preview:
            'In this blessed month of Ramadan, the importance of gratitude, reflection, and giving is taught all over again. As you commemorate this season, may these virtues be once more inspired in you.',
      },
      {
         id: 6,
         category: 'Eid (Muslim holidays)',
         preview:
            'As you go into the Ramadan season to reflect on your devotion to Allah, may you be granted clarity in all the ways you seek them. Ramadan Kareem!',
      },
      {
         id: 7,
         category: 'Christmas and New Year',
         preview:
            'Merry Christmas! May your heart be light, your home be bright, and your season be filled with love and joy. Wishing you peace and happiness!',
      },
      {
         id: 8,
         category: 'Christmas and New Year',
         preview:
            'Wishing you a Christmas filled with love, laughter, and unforgettable memories! Merry Christmas and a Happy New Year to you and yours.',
      },
      {
         id: 9,
         category: 'Christmas and New Year',
         preview:
            'Season’s Greetings! May your Christmas wishes be unwrapped with happiness and all the love Santa Claus brings you. Wishing you the very best of the season!',
      },
      {
         id: 10,
         category: 'Christmas and New Year',
         preview:
            'Happy New Year! May 2025 bring you success, happiness, and countless reasons to smile. Cheers to a fresh start of greater possibilities!',
      },
      {
         id: 11,
         category: 'Christmas and New Year',
         preview:
            'New Year, New Opportunities! May 2025 bring you growth, happiness, and all your heart desires. Cheers to an amazing year ahead!',
      },
      {
         id: 12,
         category: 'Christmas and New Year',
         preview:
            'Everything good you have asked for would come in 2025 so dive into the year with faith and courage. Cheers to new beginnings and a prosperous new year!',
      },
      {
         id: 13,
         category: 'Valentine’s Day',
         preview:
            "Happy Valentine’s Day! Whether you're celebrating love, friendship, or self-care, may today be a reminder of how special you truly are!",
      },
      {
         id: 14,
         category: 'Valentine’s Day',
         preview:
            'Every day with you is special, but today is a sweet reminder of how much you mean to me. You’re forever my Valentine. Happy Valentine’s Day, my love!',
      },
      {
         id: 15,
         category: 'Valentine’s Day',
         preview:
            'Who needs Cupid when we have amazing friends like you? Happy Valentine’s Day! Wishing you love, laughter, and lots of chocolate!',
      },
      {
         id: 16,
         category: 'Valentine’s Day',
         preview:
            'Roses are red, violets are blue, and you, our dear amazing customer, is why we are still blooming. Thank you for sticking with us through every phase of this journey! Happy Valentine’s Day, (name). We value you!',
      },
      {
         id: 17,
         category: 'Independence Day Celebrations',
         preview:
            'Today, we celebrate the courage and sacrifices that brought us freedom! May this freedom translate to other parts of your lives, giving you the privileges to thrive fully. Happy Independence Day! May our nation continue to thrive.',
      },
      {
         id: 18,
         category: 'Independence Day Celebrations',
         preview:
            'Celebrate Independence Day with us by enjoying a (discount/offer) when you place your order or book our service today. Happy Independence Day!',
      },
      {
         id: 19,
         category: 'Independence Day Celebrations',
         preview:
            'As freedom, unity, and progress continues to keep us as one, we’re grateful to continually serve you. Enjoy special Independence Day deals from us when you shop here: (link) today.',
      },
      {
         id: 20,
         category: 'Exam reminders',
         preview:
            'Here is a reminder for the forthcoming examinations which is to take place on the (date). Do well to study ahead in order to pass with flying colors.',
      },
      {
         id: 21,
         category: 'Exam reminders',
         preview:
            'Examinations are not the test of intelligence but a proof of your preparedness for the next phase of life. Come prove to yourself on the (date) at (venue) that you are ready for the next step. Good luck ahead!',
      },
      {
         id: 22,
         category: 'Exam reminders',
         preview:
            'Dear students, this is a reminder to you that your (subject) examinations would still be holding on the (date) at (venue). We wish you the best ahead as you study efficiently ahead.',
      },
      {
         id: 23,
         category: 'Fee payment notifications',
         preview:
            "Hello (Name), we hope you're doing well? This is a gentle reminder that your payment of (amount) for (fee type) is due on the [Due Date]. Please complete your payment at your earliest convenience to avoid possible consequences. Thank you!",
      },
      {
         id: 24,
         category: 'Fee payment notifications',
         preview:
            'This is a kind reminder that your (Fee Type) payment of (Amount) is due on (Due Date). Kindly ensure payment is made by the due date to avoid late fees. Thank you!',
      },
      {
         id: 25,
         category: 'Fee payment notifications',
         preview:
            'Dear (Name), your payment for (Fee Type) was due on (Due Date) and remains unpaid. Please make the payment by (Final Deadline) to avoid further action. We appreciate your immediate attention.',
      },
      {
         id: 26,
         category: 'Webinar or workshop Invitations',
         preview:
            'Hi [Name]! Our [Topic] webinar/workshop on [Date] is almost full! Don’t miss your chance at scaling up your (workshop purpose), secure your spot now using [Registration Link]. We hope to see you there!',
      },
      {
         id: 27,
         category: 'Webinar or workshop Invitations',
         preview:
            'You just secured a special invitation to our upcoming exclusive (topic) webinar/workshop. It’s happening on (date) at (time), and we’d love for you to be there. You have 24 hours to secure your spot here (registration link) before it’s closed!',
      },
      {
         id: 28,
         category: 'Webinar or workshop Invitations',
         preview:
            'Hi (name), spots are filling up fast for our (topic) webinar/workshop holding on the (date) at (time). Register now via (registration link) before it’s too late. We’d love to have you join us!',
      },
      {
         id: 29,
         category: 'Fundraising campaigns',
         preview:
            'Hi (Name), we’re reaching out because we know how passionate you are about (cause). Your support can help us achieve this [specific goal]. Please donate today via (link) and let’s make a real difference together.',
      },
      {
         id: 30,
         category: 'Fundraising campaigns',
         preview:
            'Dear (Name), you’ve always been an admirable champion of (cause), and now we need your help more than ever. Your donation would go a long way in significantly achieving this (specific goal). Kindly send your contributions via (medium). Thank you for your continuous support!',
      },
      {
         id: 31,
         category: 'Fundraising campaigns',
         preview:
            'Imagine a world where (impact of the campaign). We’re working hard to make that world a reality for (target audience), but we can’t do it without you as we believe your donation can help us bring change. Send in your donations via (Link). Thank you for your kindness!',
      },
      {
         id: 32,
         category: 'Event invites',
         preview:
            'Great news! Here’s a cordial invite to (Event Name), a gathering of industry leaders and professionals happening on (date) at (time) at (Location). Don’t miss out on valuable insights and networking! RSVP now using the link or reply YES to confirm.',
      },
      {
         id: 33,
         category: 'Event invites',
         preview:
            'Hey (name)! We’re bringing together amazing minds at (event name) for an evening of great conversations and connections. Join us on (date) at (time) at (venue) let’s make it happen! Click here (link) to secure a spot now!',
      },
      {
         id: 34,
         category: 'Event invites',
         preview:
            'It’s a party!!! (Occasion name) would not be complete without you! Grace us with your presence on the (date) at (time) at (venue) for a moment of fun, laughter, and good vibes. Show us we can count on you? RSVP now (link).',
      },
      {
         id: 35,
         category: 'Volunteer recruitment',
         preview:
            'Would you like to join this generation of change makers to make a difference? Join us as a volunteer for (cause/event) by signing up via (link) immediately.',
      },
      {
         id: 36,
         category: 'Volunteer recruitment',
         preview:
            'Dear (name), our organization needs people like you who are dedicated to humanity to lend a hand in order to change a life today. Volunteer with us at (organization name) using this link to sign up now!',
      },
      {
         id: 37,
         category: 'Volunteer recruitment',
         preview:
            'Are you ready to be a part of something meaningful? Volunteer with us today and help make a real impact! To join us, text VOLUNTEER for more details.',
      },
      {
         id: 38,
         category: 'Weekly or special service reminders',
         preview:
            'Hey there! Join us this Sunday for worship at [Church Name]. First service starts at 8am while the second begins immediately after this at 10am. Come experience the goodness of God for yourself! See you there!',
      },
      {
         id: 39,
         category: 'Weekly or special service reminders',
         preview:
            'Dearly beloved, don’t miss our special service this weekend at [Church Name] for any reason! Christ would be expecting you on the (date) by (time) prompt. Make it a date!',
      },
      {
         id: 40,
         category: 'Weekly or special service reminders',
         preview:
            'Here’s a kind reminder that mid-week service would be holding in [Church Name] this (Day) at (Time). Come ready for spiritual growth and God’s abundant outpour. See you in church!',
      },
      {
         id: 41,
         category: 'Prayer Session Notifications',
         preview:
            'Join us for a powerful prayer session today at [time] at [venue]. Let’s seek God’s presence together! Don’t miss it.',
      },
      {
         id: 42,
         category: 'Prayer Session Notifications',
         preview:
            'Reminder: Our prayer session holds at [time] today. Come expectant and let’s call upon the Lord together! See you there.',
      },
      {
         id: 43,
         category: 'Prayer Session Notifications',
         preview:
            'Mountains move and miracles happen when we pray! Be part of our prayer session at [time] today. Let’s intercede and receive answers together. See you there!',
      },
      {
         id: 44,
         category: 'Faith-based Encouragements',
         preview:
            'Do not let your situation deter you. It’s just a matter of time, God is with you and he will calm the storms soon. Keep trusting, keep believing, your breakthrough is near!',
      },
      {
         id: 45,
         category: 'Faith-based Encouragements',
         preview:
            'Dear (name), you are not alone! God’s love surrounds you even when you don’t see it. Keep pressing forward as greater things await you ahead.',
      },
      {
         id: 46,
         category: 'Faith-based Encouragements',
         preview:
            'Hold onto faith! What seems impossible to you is possible with God as his plans for you are good. Keep the faith, the Lord is working behind the scenes.',
      },
      {
         id: 47,
         category: 'Welcome messages for new customers',
         preview:
            'Welcome onboard (Brand Name)! We’re thrilled to have you join us. Get ready for an amazing experience with [products/services]. Need help navigating a purchase?',
      },
      {
         id: 48,
         category: 'Welcome messages for new customers',
         preview:
            'Dear valued customer! Thanks for choosing (Brand Name). We’re excited to have you onboard. We can’t wait to serve you to a smooth and satisfying experience. Let’s do this!',
      },
      {
         id: 49,
         category: 'Welcome messages for new customers',
         preview:
            'Congratulations on joining the winning side! You’re now part of the [Brand Name] family. As a warm welcome, we’re offering you (offer/perk) on your first purchase. Hurry now to claim it!',
      },
      {
         id: 50,
         category: 'Feedback request templates',
         preview:
            'Thanks for choosing [Brand Name]! We are concerned about giving you value for your money which is why your feedback would help us serve you better. Kindly share your feedback with us here: (survey link).',
      },
      {
         id: 51,
         category: 'Feedback request templates',
         preview:
            'We value your feedback! Tell us what you love about our services or what you’d like for us to improve upon. Some minutes of your time would be highly appreciated. Click here to reply: (link).',
      },
      {
         id: 52,
         category: 'Feedback request templates',
         preview:
            'Hey (Customer Name)! We’d love to hear your thoughts on your experience with [Brand Name]. Reply with your feedback or rate us here: (survey link).',
      },
      {
         id: 53,
         category: 'Thank-you Note',
         preview:
            'Thank you for choosing [(Name)! Your support means the world to us. We can’t wait to serve you again if you did enjoy our services. Best regards.',
      },
      {
         id: 54,
         category: 'Thank-you Note',
         preview:
            'A big THANK YOU for being part of (Brand Name)! Your trust in the brand keeps us going. We look forward to serving you again!',
      },
      {
         id: 55,
         category: 'Thank-you Note',
         preview:
            'Dear (Customer name), your constant patronage means a lot! As a token of thanks, we’re offering you a (discount offer/freebie) on your next order. The offer window closes 14 days from today so hurry and claim it now!',
      },
      {
         id: 56,
         category: 'Birthday or Anniversary Wishes',
         preview:
            'Happy Birthday, (Name)! May your day be filled with joy, love, and laughter. Wishing you a year of blessings and success!',
      },
      {
         id: 57,
         category: 'Birthday or Anniversary Wishes',
         preview:
            'It’s your special day, (Name)! You deserve to enjoy it to the fullest. Wishing you a birthday full of happiness, fulfillment, and all your heart desires. Happy birthday, (Name).',
      },
      {
         id: 58,
         category: 'Birthday or Anniversary Wishes',
         preview:
            'As you recount all the years that have collectively added to bring you thus far, we want you to know that every win, no matter how big or small, is worthy of celebration. We can only pray for more as we wish you the best of today. Happy Anniversary, (Name).',
      },
      {
         id: 59,
         category: 'Thank-you notes After Events',
         preview:
            'We loved having you at (Event Name)! Your presence illuminated the place with so much light and energy. We look forward to seeing more of you at more exciting value packed events that will come your way soon again.',
      },
      {
         id: 60,
         category: 'Thank-you notes After Events',
         preview:
            'A huge THANK YOU for being part of (Event Name)! Your presence made it remarkable. If you haven’t yet, subscribe to our updates as we look forward to hosting you to more exciting moments.',
      },
      {
         id: 61,
         category: 'Thank-you notes After Events',
         preview:
            "Your presence at [Event Name] meant everything to me/us! Thank you for gracing the occasion with your warm aura. We can't wait to create more memories with you!",
      },
      {
         id: 62,
         category: 'Customized Notifications',
         preview:
            'Missed the best moments and highlights from (Event Name)? Relive them and download your photos here: (link). Thanks for making it special!',
      },
      {
         id: 63,
         category: 'Customized Notifications',
         preview:
            'What a fantastic time it was at (Event Name)! We know you got value but what’s more value without a recap? Catch the highlights here now: [link]. Don’t forget to also stay tuned for more updates & future events!',
      },
      {
         id: 64,
         category: 'Customized Notifications',
         preview:
            'We had a blast at (Event Name), did you? If yes, let’s keep the momentum going. Join our community & stay updated for more: (link). See you soon!',
      },
      {
         id: 65,
         category: 'Service outage notifications',
         preview:
            'Dear (Customer Name), we’re experiencing a temporary service outage after (Event Name). Our team is on it & we expect to be back by (time). Thanks for your patience!',
      },
      {
         id: 66,
         category: 'Service outage notifications',
         preview:
            'Hey there! We’re facing a temporary service issue after (Event Name) which might go on for (duration). However, our team is actively working to restore power and you will be updated shortly. Thanks for your patience!',
      },
      {
         id: 67,
         category: 'Service outage notifications',
         preview:
            'Dear valued customer, we’re fully aware of a service disruption after (Event Name) & are working to fix it as soon as possible. For more information? You can contact us at (support number/email). Thanks for your kind understanding!',
      },
      {
         id: 68,
         category: 'Urgent reminders or deadlines',
         preview:
            'Reminder: Payment for (Event Name) is due by (date). Do well to avoid late fees, complete your payment now at (link) to avoid late fee increment. Need help on how to make payment? Contact us immediately at (support).',
      },
      {
         id: 69,
         category: 'Urgent reminders or deadlines',
         preview:
            'Last chance! Registration for (Event Name) closes at (time/date). Secure your spot now at (link) before the link expires!',
      },
      {
         id: 70,
         category: 'Urgent reminders or deadlines',
         preview:
            'Hey (Name), your exclusive (event-related subscription/trial) ends on (date). Renew now to avoid losing your access using this (link). Don’t miss out!',
      },
      {
         id: 71,
         category: 'Crisis Management Updates',
         preview:
            'We’re aware of (issue) following (Event Name) & are actively investigating to make sure the issue is treated justly. Your safety & satisfaction are our top priorities, and so we appeal for your cooperation through these times.',
      },
      {
         id: 72,
         category: 'Crisis Management Updates',
         preview:
            'Following (Event Name), we’ve taken swift action to resolve (issue). Our team is working diligently on it, and would keep you duly informed. Thank you for your patience!',
      },
      {
         id: 73,
         category: 'Crisis Management Updates',
         preview:
            'We value you & regret any inconvenience this (Event Name) might have caused. As a gesture, we’re offering (compensation) to make up for the distress. Kindly reach out to (support) for an immediate followup.',
      },
      {
         id: 74,
         category: 'Thank-you notes',
         preview:
            'Thank you for choosing [( Name)!  Your support means the world to us. We can’t wait to serve you again if you did enjoy our services. Best regards.',
      },
      {
         id: 75,
         category: 'Thank-you notes',
         preview:
            'A big THANK YOU for being part of (Brand Name)!  Your trust in the brand keeps us going. We look forward to serving you again! ',
      },
      {
         id: 76,
         category: 'Thank-you notes',
         preview:
            'Dear (Customer name), your constant patronage ! As a token of thanks, we’re offering you a (discount offer/freebie) on your next order. The offer window closes 14 days from today so hurry and claim it now!',
      },
   ];

   // Handle template selection
   const handleTemplateSelect = (event) => {
      setSelectedTemplate(Number(event.target.value));
   };

   // Show dialog
   const showTemplateDialog = () => {
      setIsTemplateDialogOpen(true);
   };

   // Hide dialog
   const hideTemplateDialog = () => {
      setIsTemplateDialogOpen(false);
   };

   // Use selected template
   const handleUseTemplate = () => {
      if (selectedTemplate) {
         const tem = templates.find(
            (template) => template.id === selectedTemplate
         );
         setText(tem.preview);
         hideTemplateDialog();
      }
   };

   const handlePreviewToggle = (id) => {
      setExpandedId(expandedId === id ? null : id);
   };

   const handleOpen = (event) => {
      setIsOpen(!isOpen2);
      setAnchorEl2(event.currentTarget);
   };

   const handleClose = () => {
      setIsOpen(!isOpen2);
      setAnchorEl2(null);
   };

   // Reset selections when dialog opens
   useEffect(() => {
      if (open) {
         setSelectedCategory('');
         setSelectedType('');
         setSelectedTemplate(null);
      }
   }, [open]);

   // Handle using template
   //  const handleUseTemplate = () => {
   //    const selected = templates.find(t => t.id === selectedTemplate);
   //    if (selected && onSelectTemplate) {
   //      onSelectTemplate(selected);
   //    }
   //    onClose();
   //  };

   const calculatePageCount = (text) => {
      let totalLength = text.length;
      let page = 1;
      while (totalLength > maxCharactersPerPage) {
         page++;
         totalLength -= maxCharactersPerPage;
      }
      return page;
   };

   const handleTextAreaChange = (e) => {
      const { value } = e.target;
      setMaxCharactersPerPage(value.length <= 160 ? 160 : 153);
      setText(value);
   };
   const pageCount = calculatePageCount(text);
   const remainingCharacters =
      maxCharactersPerPage - (text.length % maxCharactersPerPage);

   const handleChange = (event) => {
      setSenderId(event.target.value);
      dispatch(selectSenderId({ senderId: event.target.value }));
   };
   function getTypesByCategory(category) {
      const typesByCategory = {
         'Festive and seasonal greetings': [
            'Easter',
            'Eid (Muslim holidays)',
            'Christmas and New Year',
            'Valentine’s Day',
            'Independence Day Celebrations',
         ],
         'Educational and Informational': [
            'Exam reminders',
            'Fee payment notifications',
            'Webinar or workshop Invitations',
         ],
         'Non-Profit and NGO Messaging': [
            'Fundraising campaigns',
            'Event invites',
            'Volunteer recruitment',
         ],
         'Religious Gatherings and Events': [
            'Weekly or special service reminders',
            'Prayer Session Notifications',
            'Faith-based Encouragements',
         ],
         'Customer Engagement and Retention': [
            'Welcome messages for new customers',
            'Feedback request templates',
            'Thank-you notes',
         ],
         'Special Events and Announcements': [
            'Birthday or Anniversary Wishes',
            'Thank-you notes After Events',
            'Customized Notifications',
         ],
         'Emergency and Quick Alerts': [
            'Service outage notifications',
            'Urgent reminders or deadlines',
            'Crisis Management Updates',
         ],
      };

      return category ? typesByCategory[category] || [] : [];
   }

   React.useEffect(() => {
      if (!selector.senderIds || selector.senderIds.length < 1) {
         dispatch(fetchsenderIDs());
      }
   }, []);

   React.useEffect(() => {
      if (selector.sent === true) {
         setOpenProgress(false);
         setOpen(true);
      } else {
         setOpen(false);
      }
   }, [selector.sent === true]);
   React.useEffect(() => {
      if (selector.sending === true) {
         setSendProgress(true);
         setOpenProgress(false);
      } else {
         setSendProgress(false);
      }
   }, [selector.sending === true]);

   React.useEffect(() => {
      console.log(selector.loading);
      if (selector.loading === 'pending' && selector.sending !== true) {
         setOpenProgress(true);
      } else {
         setOpenProgress(false);
      }
   }, [selector.loading === 'pending' && selector.sending !== true]);

   React.useEffect(() => {
      if (selector.scheduled === true) {
         setScheduleSuccess(true);
      } else {
         setScheduleSuccess(false);
      }
   }, [selector.scheduled === true]);

   React.useEffect(() => {
      if (action === 'Save to Drafts') {
         setDraftOpen(true);
      }
   }, [action === 'Save to Drafts']);

   React.useEffect(() => {
      const handleBeforeUnload = (event) => {
         event.preventDefault();
         if (text !== '') {
            autoSaveDraft();
         }
      };

      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
         if (location.pathname !== '/send-message/message') {
            autoSaveDraft();
         }
         window.removeEventListener('beforeunload', handleBeforeUnload);
      };
   }, [text]);

   const forwardMessage = (values) => {
      dispatch(sendmessage(values)).then((response) => {
         setMessageId(response?.payload?.data?.id);
      });
   };

   const groupIds = selector?.selectedGroups.map((group) => group.id);
   const contactIds = selector?.selectedContacts.map((contact) => contact.id);
   const numbers = selector?.selectedNumbers;

   const newDate = dayjs(new Date());
   const currentDate = newDate.toISOString();
   const [date, setDate] = React.useState(currentDate);

   const scheduleFun = () => {
      dispatch(updateSelectedContent(text));
   };

   const getTime = (value) => {
      setDate(value);
      setPeriod(false);
   };

   const closePeriod = () => setPeriod(false);
   const draft = () => {
      if (text !== '') {
         dispatch(
            draftmessage({
               content: text,
               senderId: senderId,
               scheduledAt: currentDate,
               contactids: contactIds,
               groupids: groupIds,
               numbers,
            })
         );
         window.history.back();
      } else {
         toast.info('type a message');
      }
   };
   const autoSaveDraft = () => {
      if (text !== '') {
         dispatch(
            draftmessage({
               content: text,
               senderId: senderId,
               scheduledAt: currentDate,
               contactids: contactIds,
               groupids: groupIds,
               numbers,
            })
         );
         // window.history.back();
      }
   };

   const handleMenu = (value) => {
      setAction(value);
      setAnchorEl(null);
   };
   const setClose = () => setAnchorEl(false);

   const send = (values) => {
      if (text !== '' && schedule === false) {
         forwardMessage(values);
         setText('');
      } else if (text !== '' && schedule === true) {
         dispatch(schedulemessage(values));
         setText('');
         setSchedule(false);
      } else {
         toast.info('type a message');
      }
   };

   // React.useEffect(() => {
   //    dispatch(
   //       getMsgCost({
   //          content: '',
   //          senderId: senderId,
   //          scheduledAt: date,
   //          contactids: contactIds,
   //          groupids: groupIds,
   //          numbers,
   //       })
   //    );
   // }, [selector?.selectedContacts || selector?.selectedGroups]);

   React.useEffect(() => {
      if (selector.msgCost?.dNDCount || selector.msgCost?.nonDNDCount) {
         setNumOfContacts(
            selector.msgCost.dNDCount + selector.msgCost.nonDNDCount
         );
      } else {
         setNumOfContacts(0);
         setNumOfContacts(0);
      }
   }, [selector.msgCost]);

   const resetInsufficient = () => {
      setInsufficient(false);
   };

   const resetMsgSummary = () => {
      setOpenSummary(false);
   };

   return (
      <Container>
         <NotificationPopup />
         <Card
            sx={{
               width: { xs: '95%', sm: '90%' },
               maxWidth: '655px',
               minHeight: { xs: '70vh', sm: '80vh' },
               margin: '0 auto',
               marginTop: { xs: '1rem', sm: '2rem' },
               position: 'relative',
               boxShadow:
                  '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
               padding: { xs: '15px', sm: '20px' },
               background: 'white',
            }}
         >
            <Box
               sx={{
                  margin: '0 auto',
                  marginTop: '1rem',
                  border: '1px solid transparent',
                  position: 'relative',
               }}
            >
               <img
                  src={backImg}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '40px',
                     cursor: 'pointer',
                     top: '10px',
                     // border: '1px solid',
                  }}
                  onClick={() => {
                     if (text !== '') {
                        setDraftOpen(true);
                     } else {
                        window.history.back();
                     }
                  }}
               />
               <DropDown
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={setClose}
                  MenuListProps={{
                     'aria-labelledby': 'basic-button',
                  }}
               >
                  {actions.map((action, index) => (
                     <Activity
                        key={index}
                        onClick={(e) => handleMenu(e.target.innerText)}
                     >
                        {action}
                     </Activity>
                  ))}
               </DropDown>

               <img
                  src={verticalMenu}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '30px',
                     top: '10px',
                     right: 0,
                     filter:
                        'invert(27%) sepia(11%) saturate(7243%) hue-rotate(207deg) brightness(94%) contrast(88%)',
                     cursor: 'pointer',
                  }}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
               />
               <Typography
                  sx={{
                     width: 'max-content',
                     margin: '0 auto',
                     fontWeight: 600,
                     fontSize: {
                        xs: '2rem',
                        sm: '1.5rem',
                        md: '2rem',
                        lg: '2.3rem',
                     },
                     color: '#2E2C21',
                     marginTop: '0rem',
                     textAlign: 'center',
                     px: { xs: 1, sm: 0 },
                  }}
                  className="font-cormorant"
               >
                  Send Message
               </Typography>

               <Typography
                  sx={{
                     margin: '1.5rem 0 0.5rem 0',
                     fontWeight: 400,
                     fontSize: { xs: '1rem', sm: '1.1rem', md: '1.3rem' },
                     color: '#2E2C21',
                     marginTop: '2rem',
                  }}
               >
                  Sender ID
               </Typography>
               <FormControl fullWidth>
                  <Select
                     id="demo-simple-select"
                     value={senderId}
                     onChange={handleChange}
                     sx={{
                        backgroundColor: '#fff',
                        fontWeight: 600,
                        padding: '25px 0 !important',

                        '& .MuiOutlinedInput-notchedOutline': {
                           borderColor: '#E5E5E5',
                        },
                     }}
                  >
                     {selector?.senderIds ? (
                        selector?.senderIds
                           .filter((x) => x.status == 'approved')
                           .map((senderId, index) => (
                              <MenuItem value={senderId?.senderId} key={index}>
                                 {senderId?.senderId}
                              </MenuItem>
                           ))
                     ) : (
                        <MenuItem value={1}>No Sender Ids</MenuItem>
                     )}
                  </Select>
               </FormControl>

               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                  }}
               >
                  <Typography
                     sx={{
                        margin: '1.5rem 0 0.5rem 0',
                        fontWeight: 400,
                        fontSize: { xs: '1rem', sm: '1.1rem', md: '1.3rem' },
                        color: '#2E2C21',
                     }}
                  >
                     Recipients
                  </Typography>
                  <Typography
                     sx={{
                        margin: '1.5rem 0 0 0',
                        fontWeight: 400,
                        color: '#374da0',
                        cursor: 'pointer',
                     }}
                     onClick={() => {
                        dispatch(resetSelectedContacts());
                     }}
                  >
                     Clear
                  </Typography>
               </Box>
               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     position: 'relative',
                  }}
               >
                  <Box
                     sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignContent: 'flex-start',
                        bgcolor: 'background.paper',
                        maxHeight: 10,
                        border: '1px solid #E5E5E5',
                        minHeight: { xs: '50px', sm: '60px' },
                        background: '#fff',
                        borderRadius: '5px',
                        padding: { xs: '8px', sm: '10px' },
                        paddingRight: { xs: '35px', sm: '40px' },
                        overflow: 'auto',
                        width: '100%',
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'grey',
                        // '&::-webkit-scrollbar': {
                        //    width: 0,
                        //    height: 0,
                        // },
                     }}
                  >
                     {selector?.selectedGroups.length > 0
                        ? selector?.selectedGroups.map((item, id) => (
                             <GroupContent key={id} item={item} />
                          ))
                        : null}
                     {selector.selectedContacts.length > 0
                        ? selector.selectedContacts.map((item, id) => (
                             <ContactContent key={id} item={item} />
                          ))
                        : null}

                     {selector.selectedNumbers.length > 0
                        ? selector.selectedNumbers.map((item, id) => (
                             <ContactContent key={id} item={{ number: item }} />
                          ))
                        : null}
                  </Box>
                  <img
                     src={contactImg}
                     alt="icon"
                     style={{
                        cursor: 'pointer',
                        marginLeft: '5px',
                     }}
                     onClick={() => {
                        dispatch(updateSelectedContent(text));
                        setAdd(true);
                     }}
                  />
               </Box>

               <Typography
                  sx={{
                     margin: '1.2rem 0',
                     display: 'flex',
                     alignItems: 'center',
                     fontWeight: 400,
                     fontSize: { xs: '0.9rem', sm: '1rem' },
                     color: '#0040BF',
                     cursor: 'pointer',
                     width: '100%',
                     textDecoration: 'underline',
                     flexWrap: { xs: 'wrap', sm: 'nowrap' },
                     gap: { xs: 1, sm: 0 },
                  }}
                  onClick={() => {
                     dispatch(
                        getMsgCost({
                           content: text,
                           senderId: senderId,
                           scheduledAt: date,
                           contactids: contactIds,
                           groupids: groupIds,
                           numbers,
                        })
                     );
                     setOpenSummary(true);
                  }}
               >
                  <img src={cost} alt="icon" style={{ marginRight: '10px' }} />
                  View Pricing Info
               </Typography>

               <Typography
                  sx={{
                     fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                     color: '#555',
                     display: 'inline',
                     fontWeight: 400,
                     mt: 2,
                     lineHeight: { xs: 1.4, sm: 1.5 },
                  }}
               >
                  Avoid use of{' '}
                  <strong
                     style={{
                        fontWeight: 800,
                        fontSize: { xs: '1.1rem', sm: '1.2rem', md: '1.3rem' },
                     }}
                  >
                     "&"
                  </strong>{' '}
                  as it truncates the message.{' '}
               </Typography>

               <Link
                  to="/send-message/rules"
                  style={{ textDecoration: 'none', color: '#0040BF' }}
               >
                  <Typography
                     sx={{
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        color: '#0040BF',
                        display: 'inline',
                        fontSize: { xs: '0.9rem', sm: '1rem', md: '1.05rem' },
                        fontWeight: 600,
                     }}
                  >
                     Learn more...
                  </Typography>
               </Link>
               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     marginTop: '1.3rem',
                     marginBottom: '1rem',

                     gap: { xs: 1, sm: 0 },
                     alignItems: { xs: 'flex-start', sm: 'center' },
                  }}
               >
                  <Typography
                     sx={{
                        fontWeight: 400,
                        fontSize: { xs: '1rem', sm: '1.1rem', md: '1.3rem' },
                        color: '#2E2C21',
                     }}
                  >
                     Your Message
                  </Typography>
                  <Typography
                     sx={{
                        fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                        textDecoration: 'underline',
                        cursor: 'pointer',
                        color: '#0040BF',
                        fontWeight: '500',
                     }}
                     onClick={showTemplateDialog}
                  >
                     Open Templates
                  </Typography>
               </Box>

               <Textarea
                  style={{ marginTop: '0 ' }}
                  name="desc"
                  aria-label="about"
                  minRows={1}
                  // placeholder='Enter message here...'
                  onChange={handleTextAreaChange}
                  value={text}
                  variant="outlined"
                  id="group_desc"
               />

               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     marginBottom: '2rem',
                     flexDirection: { xs: 'column', sm: 'row' },
                     gap: { xs: 1, sm: 0 },
                     alignItems: { xs: 'flex-start', sm: 'center' },
                  }}
               >
                  <Typography
                     sx={{
                        width: 'max-content',
                        color: '#58564d',
                        fontWeight: '400',
                        fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                     }}
                  >
                     {remainingCharacters}/{pageCount}
                  </Typography>
                  <Typography
                     sx={{
                        width: 'max-content',
                        color: '#58564d',
                        fontWeight: '400',
                        fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                     }}
                  >
                     {`contacts:`}
                     {numOfContacts}
                  </Typography>
               </Box>

               <Button
                  disabled={
                     text.length === 0 ||
                     !senderId ||
                     (!contactIds?.length &&
                        !groupIds?.length &&
                        !numbers?.length)
                  }
                  sx={{
                     width: { xs: '100%', sm: '400px' },
                     height: { xs: '50px', sm: '45px' },
                     margin: '1.5rem auto',
                     borderRadius: '8px',
                     backgroundColor: '#374DA0',
                     color: '#fff',
                     display: 'flex',
                     justifyContent: 'center',
                     ':hover': {
                        backgroundColor: '#374DA0',
                     },
                  }}
               >
                  <Typography
                     sx={{
                        textAlign: 'center',
                        width: { xs: '70%', sm: '80%' },
                        padding: '5px',
                        cursor: 'pointer',
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                     }}
                     onClick={async () => {
                        try {
                           // Properly wait for the thunk to complete and get its result
                           const resultAction = await dispatch(
                              getMsgCost({
                                 content: text,
                                 senderId,
                                 scheduledAt: date,
                                 contactids: contactIds,
                                 groupids: groupIds,
                                 numbers,
                              })
                           );

                           // Check if the action was fulfilled (not rejected)
                           if (getMsgCost.fulfilled.match(resultAction)) {
                              const updatedCost =
                                 resultAction.payload.totalCost || 0;
                              const userBalance = userLSAuth()?.balance || 0;

                              console.log(updatedCost, userBalance);

                              if (updatedCost > userBalance) {
                                 setInsufficient(true);
                                 return;
                              }

                              // If balance is sufficient, proceed with sending
                              dispatch(
                                 send({
                                    content: text,
                                    senderId,
                                    scheduledAt: date,
                                    contactids: contactIds,
                                    groupids: groupIds,
                                    numbers,
                                 })
                              );
                           }
                        } catch (error) {
                           console.error('An error occurred:', error);
                        }
                     }}
                  >
                     Send Message
                  </Typography>
                  {!(
                     text.length === 0 ||
                     !senderId ||
                     (!contactIds?.length &&
                        !groupIds?.length &&
                        !numbers?.length)
                  ) && (
                     <>
                        <Divider
                           orientation="vertical"
                           flexItem
                           sx={{
                              height: '25px',
                              margin: '0 10px',
                              background: 'grey',
                           }}
                        />
                        <Typography onClick={handleOpen}>
                           <img
                              src={up}
                              alt="back"
                              style={{
                                 cursor: 'pointer',
                                 transform: isOpen2
                                    ? 'rotate(0deg)'
                                    : 'rotate(180deg)',
                                 transition: 'transform 0.3s ease',
                              }}
                           />
                        </Typography>
                     </>
                  )}
               </Button>
               <Popover
                  open={isOpen}
                  anchorEl={anchorEl2}
                  onClose={handleClose}
                  anchorOrigin={{
                     vertical: 'top',
                     horizontal: 'center',
                  }}
                  PaperProps={{
                     sx: {
                        borderRadius: 0.5,
                        mt: -2.3,
                        ml: -7,
                        padding: 0.6,
                        backdropFilter: 'none',
                        filter: 'none',
                     },
                  }}
                  transformOrigin={{
                     vertical: 'bottom',
                     horizontal: 'center',
                  }}
               >
                  <Typography
                     sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        borderLeft: '1px solid #fff',
                        padding: '10px',
                        cursor: 'pointer',
                        gap: '8px',
                     }}
                     onClick={() => {
                        navigate('/send-message/schedule-message');
                        scheduleFun();
                     }}
                  >
                     <img src={scheduleImg} alt="icon" />
                     <Typography
                        style={{
                           fontWeight: '700',
                           fontSize: { xs: '0.7rem', sm: '0.8rem' },
                           color: '#374DA0',
                        }}
                     >
                        Schedule Message
                     </Typography>
                  </Typography>
               </Popover>
               <Dialog onClose={() => setPeriod(false)} open={period}>
                  <ScheduleDate getTime={getTime} closePeriod={closePeriod} />
               </Dialog>
               <Dialog
                  onClose={() => {
                     setAction('');
                     setDraftOpen(false);
                  }}
                  open={draftOpen}
               >
                  <Card sx={{ padding: '20px 55px' }}>
                     <Typography
                        sx={{
                           textAlign: 'center',
                           marginBottom: '2rem',
                           fontWeight: 600,
                           fontSize: { xs: '0.9rem', sm: '1rem' },
                        }}
                     >
                        Save this message as a draft?
                     </Typography>
                     <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography
                           sx={{
                              fontWeight: 600,
                              fontSize: { xs: '0.9rem', sm: '1rem' },
                              color: '#374DAO',
                              marginRight: '1rem',
                              cursor: 'pointer',
                           }}
                           onClick={() => draft()}
                        >
                           Save as Draft
                        </Typography>
                        <Typography
                           sx={{
                              fontWeight: 600,
                              fontSize: { xs: '0.9rem', sm: '1rem' },
                              color: '#374DAO',
                              cursor: 'pointer',
                           }}
                           onClick={() => window.history.back()}
                        >
                           Discard
                        </Typography>
                     </Box>
                  </Card>
               </Dialog>
               <Dialog onClose={() => setAdd(false)} open={add}>
                  <MessageContact
                     contactText={'/send-message/select-contact'}
                     groupsText={'/send-message/select-group'}
                     pasteText={'/send-message/select-paste'}
                  />
               </Dialog>
               <Dialog onClose={() => setSelectGroup(false)} open={selectGroup}>
                  <GroupSelect />
               </Dialog>
               <Dialog onClose={() => setOpenSummary(false)} open={openSummary}>
                  <MessageSummary resetMsgSummary={resetMsgSummary} />
               </Dialog>
               <Dialog
                  onClose={() => {
                     setOpen(false);
                     dispatch(resetCreated());
                  }}
                  open={open}
               >
                  <Success id={messageId} msgType="Message Sent!" />
               </Dialog>

               <Dialog
                  onClose={() => setScheduleSuccess(false)}
                  open={scheduleSuccess}
               >
                  <Success msgType="Message Scheduled Successfully!" />
               </Dialog>

               <Dialog
                  onClose={() => setInsufficient(false)}
                  open={insufficient}
               >
                  <InsufficientSmsDialog
                     resetInsufficient={resetInsufficient}
                  />
               </Dialog>

               <Dialog
                  onClose={() => {
                     setOpenProgress(false);
                  }}
                  open={openProgress}
               >
                  <div
                     style={{
                        background: '#555',
                        overflowX: 'hidden',
                        overflowY: 'hidden',
                        background: 'none',
                        padding: '10px',
                        backgroundColor: '#374DA0',
                     }}
                  >
                     <CircularProgress
                        style={{
                           color: 'white',
                        }}
                     />
                  </div>
               </Dialog>

               <Dialog
                  onClose={() => {
                     setSendProgress(false);
                  }}
                  open={sendProgress}
               >
                  <div
                     style={{
                        padding: '10px',

                        textAlign: 'center',
                     }}
                  >
                     <img
                        src={sendingImg}
                        alt="Sending"
                        style={{
                           width: '100%',
                           maxWidth: '25rem',
                           height: 'auto',
                           padding: '0 2rem',
                        }}
                     />
                     <Box
                        sx={{
                           display: 'flex',
                           justifyContent: 'center',
                           alignItems: 'center',
                           fontWeight: 'bold',
                           fontSize: {
                              xs: '0.9rem',
                              sm: '1.25rem',
                              md: '1.5rem',
                           },
                           textAlign: 'center',
                           padding: {
                              xs: '1rem',
                              sm: '2rem',
                              md: '3rem',
                           },
                        }}
                     >
                        Sending Message...
                     </Box>
                  </div>
               </Dialog>
               <Dialog
                  open={isTemplateDialogOpen}
                  onClose={hideTemplateDialog}
                  maxWidth="lg"
                  fullWidth
                  PaperProps={{
                     sx: {
                        borderRadius: 2,
                        boxShadow: '0px 5px 15px rgba(0, 0, 0, 0.1)',
                        background: '#f8f8f8',
                        maxHeight: { xs: '90vh', sm: '80vh', md: '80vh' },
                        height: 'auto',
                        width: { xs: '95%', sm: '720px', md: '840px' },
                        margin: { xs: '10px', sm: 'auto' },
                        padding:'1rem'
                     },
                  }}
               >
                  <DialogTitle
                     sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        pb: 1,
                        borderBottom: '1px solid #E5E5E5', // 👈 border added here
                        paddingBottom: '0.1rem',
                     }}
                  >
                     <Typography
                        className="font-cormorant"
                        variant="h6"
                        sx={{
                           marginY: '0.5rem',
                           fontWeight: '600',
                           color: '#2E2C21',
                           fontSize: { xs: '1.1rem', sm: '1.8rem' },
                         
                        }}
                        component="div"
                     >
                        Use a Template
                     </Typography>
                  </DialogTitle>

                  <DialogContent sx={{ pt: 0, pb: 2, mb: 0, mt: 2 }}>
                     {/* Two select inputs side by side */}
                     <Box
                        sx={{
                           display: 'flex',
                           gap: { xs: 1, sm: 2 },
                           mb: 3,
                           flexDirection: { xs: 'column', sm: 'row' },
                        }}
                     >
                        {/* Category Select */}
                        <FormControl fullWidth>
                           <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{
                                 fontWeight: '500',
                                 color: '#2E2C21',
                                 mb: '7px',
                                 fontSize: { xs: '0.85rem', sm: '1.1rem' },
                              }}
                           >
                              Select a category
                           </Typography>

                           <Select
                              value={selectedCategory || ''}
                              onChange={(e) => {
                                 const category = e.target.value;
                                 setSelectedCategory(category);
                                 // Reset type when category changes
                                 setSelectedType('');
                                 // Reset template when category changes
                                 setSelectedTemplate(null);
                              }}
                              label="Select a category"
                              sx={{ borderRadius: 1 }}
                           >
                              <MenuItem value="Festive and seasonal greetings">
                                 Festive and seasonal greetings
                              </MenuItem>
                              <MenuItem value="Educational and Informational">
                                 Educational and Informationals
                              </MenuItem>
                              <MenuItem value="Non-Profit and NGO Messaging">
                                 Non-Profit and NGO Messaging
                              </MenuItem>
                              <MenuItem value="Religious Gatherings and Events">
                                 Religious Gatherings and Events
                              </MenuItem>
                              <MenuItem value="Customer Engagement and Retention">
                                 Customer Engagement and Retention
                              </MenuItem>
                              <MenuItem value="Special Events and Announcements">
                                 Special Events and Announcements
                              </MenuItem>
                              <MenuItem value="Emergency and Quick Alerts">
                                 Emergency and Quick Alerts
                              </MenuItem>
                           </Select>
                        </FormControl>

                        {/* Type Select - options depend on selected category */}
                        <FormControl fullWidth disabled={!selectedCategory}>
                           <Typography
                              variant="subtitle1"
                              gutterBottom
                              sx={{
                                 fontWeight: '500',
                                 color: '#2E2C21',
                                 mb: '7px',
                                 fontSize: { xs: '0.85rem', sm: '1.1rem' },
                              }}
                           >
                              Select a type
                           </Typography>

                           <Select
                              value={selectedType || ''}
                              onChange={(e) => {
                                 setSelectedType(e.target.value);
                                 // Reset template when type changes
                                 setSelectedTemplate(null);
                              }}
                              label="Select a type"
                              sx={{ borderRadius: 1 }}
                           >
                              {getTypesByCategory(selectedCategory).map(
                                 (type) => (
                                    <MenuItem key={type} value={type}>
                                       {type}
                                    </MenuItem>
                                 )
                              )}
                           </Select>
                        </FormControl>
                     </Box>

                     {/* Template select below */}
                     <Box sx={{ mb: 3 }}>
                        <Typography
                           variant="subtitle1"
                           gutterBottom
                           sx={{
                              fontWeight: '500',
                              color: '#2E2C21',
                              mb: '7px',
                              fontSize: { xs: '0.85rem', sm: '1.1rem' },
                           }}
                        >
                           Select template
                        </Typography>
                        <FormControl fullWidth disabled={!selectedType}>
                           <Select
                              value={selectedTemplate || ''}
                              onChange={handleTemplateSelect}
                              displayEmpty
                              sx={{ borderRadius: 1 }}
                              renderValue={(selected) => {
                                 if (!selected)
                                    return 'Select a template from the dropdown';
                                 const template = templates.find(
                                    (t) => t.id === selected
                                 );
                                 return template
                                    ? `${template.category}: ${_.truncate(
                                         template.preview,
                                         { length: 40 }
                                      )}`
                                    : '';
                              }}
                           >
                              {templates
                                 .filter(
                                    (template) =>
                                       !selectedType ||
                                       template.category === selectedType
                                 )
                                 .map((template) => (
                                    <MenuItem
                                       key={template.id}
                                       value={template.id}
                                    >
                                       <Typography
                                          variant="body2"
                                          sx={{
                                             fontWeight: 500,
                                             fontSize: {
                                                xs: '0.8rem',
                                                sm: '0.875rem',
                                             },
                                          }}
                                       >
                                          {template.category}
                                       </Typography>
                                       <Typography
                                          variant="body2"
                                          sx={{
                                             ml: 1,
                                             fontSize: {
                                                xs: '0.8rem',
                                                sm: '0.875rem',
                                             },
                                          }}
                                       >
                                          -{' '}
                                          {_.truncate(template.preview, {
                                             length: 40,
                                          })}
                                       </Typography>
                                    </MenuItem>
                                 ))}
                           </Select>
                        </FormControl>
                     </Box>

                     {/* Preview area */}
                     <Box sx={{ mb: 2 }}>
                        <Typography
                           variant="subtitle1"
                           gutterBottom
                           sx={{
                              fontWeight: '500',
                              color: '#2E2C21',
                              mb: '7px',
                              fontSize: { xs: '0.85rem', sm: '1.1rem' },
                           }}
                        >
                           Preview
                        </Typography>
                        <TextField
                           multiline
                           rows={5}
                           fullWidth
                           value={
                              selectedTemplate
                                 ? templates.find(
                                      (t) => t.id === selectedTemplate
                                   )?.preview || ''
                                 : 'Your message will appear here...'
                           }
                           InputProps={{
                              readOnly: true,
                              sx: {
                                 height: '250px',
                                 '& .MuiInputBase-input': {
                                    height: '100%',
                                    overflowY: 'auto',
                                    padding: '16px',
                                 },
                              },
                           }}
                           sx={{
                              borderRadius: 1,
                              backgroundColor: 'white',
                              '& .MuiOutlinedInput-root': {
                                 height: '150px',
                              },
                           }}
                        />
                     </Box>
                  </DialogContent>

                  <DialogActions sx={{ px: 1, pb: 2, pt: 0, marginRight: 2 }}>
                     <Button
                        onClick={hideTemplateDialog}
                        sx={{
                           borderRadius: 1,
                           px: 1,
                           py: 0.5,
                           fontSize: { xs: '0.85rem', sm: '1rem' },
                           textTransform: 'none',
                           color: '#374DA0',
                        }}
                     >
                        Cancel
                     </Button>
                     <Button
                        onClick={handleUseTemplate}
                        disabled={!selectedTemplate}
                        variant="outlined"
                        sx={{
                           borderRadius: '8px',
                           px: 1.5,
                           py: 0.5,
                           fontSize: { xs: '0.85rem', sm: '1rem' },
                           borderColor: '#5d69e3',
                           color: '#5d69e3',
                           textTransform: 'none',
                           '&:hover': {
                              backgroundColor: '#e9eafb',
                              borderColor: '#374DA0',
                           },
                        }}
                     >
                        Use Template
                     </Button>
                  </DialogActions>
               </Dialog>
            </Box>
         </Card>
      </Container>
   );
};

export default Message;
